// extracted by mini-css-extract-plugin
export default {"root":"CustomDragPreview_root__GRt6G","icon":"CustomDragPreview_icon__AGnBW","label":"CustomDragPreview_label__Z3z22"};